import { Button } from '@/components/common/Button';
import { useTranslation } from 'react-i18next';

interface HomeIntroduceProps {
    advertisementUrl?: string,
    onReadMore?: () => void
}

export default function HomeIntroduce({ advertisementUrl, onReadMore }: HomeIntroduceProps) {
    // hook
    const { t } = useTranslation();

    return (
        <div className='flex flex-col md:flex-row gap-12'>
            <div className='flex flex-col justify-center md:aspect-square md:w-1/2 xl:mr-24'>
                <div className='flex flex-col gap-6'>
                    <h3 className='text-4xl font-semibold whitespace-pre-line'>{t('home.introduce_title')}</h3>
                    <p className='text-base'>{t('home.introduce_content')}</p>
                    <div className='ml-6 xl:ml-24'>
                        <p className='text-base font-semibold'>{t('home.flexible_title')}</p>
                        <p className='text-base mt-2 whitespace-pre-line'>
                            {t('home.flexible_content')}
                        </p>
                    </div>
                    <div className='ml-6 xl:ml-24'>
                        <p className='text-base font-semibold'>{t('home.professional_title')}</p>
                        <p className='text-base mt-2'>
                            {t('home.professional_content')}
                        </p>
                    </div>
                    <Button className='w-64 self-center' onClick={onReadMore}>{t('button.read_more')}</Button>
                </div>
            </div>
            <img className='md:aspect-square md:w-1/2 object-contain' src={advertisementUrl} alt='advertisement' />
        </div>
    );
}
